export default function useShowPlaces({ route }) {
  return ["Categoria", "SubCategoria", "Results"].includes(route.name);
}
